module.exports = __webpack_public_path__ + "img/Group 1421 (3).df335db7.png";